<template>
  <div class="search-machine">
    <div class="el-search vue-top-padding">
      <el-row :gutter="20" style="margin: 0">
        <el-col :span="8" style="padding: 0">
          <div class="el-left">
            <el-button
              type="primary"
              size="small"
              v-hasPerm="['machine:insert']"
              icon="el-icon-plus"
              @click="addMachine"
              >{{ $t("common.add") }}</el-button
            >
            <el-button
              size="small"
              v-hasPerm="['machine:import']"
              icon="el-icon-folder-opened"
              @click="importMachine"
              >{{ $t("common.import") }}</el-button
            >
            <el-button size="small" v-hasPerm="['machine:export']" icon="el-icon-receiving" @click="exportMachine">{{
              $t("common.export")
            }}</el-button>
            <el-button
              type="danger"
              v-hasPerm="['machine:recover']"
              size="small"
              icon="el-icon-delete"
              :disabled="multipleSelection.length <= 0"
              @click="recoverMachine"
              style="margin: 0"
              >{{ $t("searchMachine.recover") }}</el-button
            >
            <el-button
              type="success"
              v-hasPerm="['machine:insert']"
              size="small"
              icon="el-icon-plus"
              @click="quickAddMachine"
              style="margin-left: 10px"
              >{{ $t("searchMachine.quickAdd") }}</el-button
            >
          </div>
        </el-col>
        <el-col :span="16" style="padding: 0">
          <div class="el-right">
            <el-form
              ref="machine"
              :model="search"
              :inline="true"
              label-width="10px"
              size="small"
              class="demo-form-inline el-input-height"
            >
              <el-form-item prop="userName" style="margin: 0 10px 0 0">
                <el-input v-model="search.userName" @input="onSubmit" :placeholder="$t('admin.SearchMachine.515623-0')"></el-input>
              </el-form-item>
              <el-form-item prop="equipmentName" style="margin: 0 10px 0 0">
                <el-input v-model="search.equipmentName" @input="onSubmit" :placeholder="$t('searchMachine.name')"></el-input>
              </el-form-item>
              <el-form-item prop="teamId" style="margin: 0 10px 0 0">
                <el-select v-model="search.teamId" filterable :placeholder="$t('searchMachine.teamId')">
                  <el-option
                    v-for="item in machineGroup"
                    :no-data-text="$t('common.noData')"
                    :no-match-text="$t('common.noData')"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="typeId" style="margin: 0 10px 0 0">
                <el-select
                  v-model="search.typeId"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  filterable
                  :placeholder="$t('searchMachine.typeId')"
                >
                  <el-option v-for="item in machineType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="equipmentNo" style="margin: 0 10px 0 0">
                <el-input v-model="search.equipmentNo" @input="onSubmit" :placeholder="$t('searchMachine.equipmentNo')"></el-input>
              </el-form-item>
              <el-form-item prop="sell" style="margin: 0 10px 0 0">
                <el-select
                  v-model="search.sell"
                  :no-data-text="$t('common.noData')"
                  :no-match-text="$t('common.noData')"
                  filterable
                  :placeholder="$t('searchMachine.yesNo')"
                >
                  <el-option v-for="item in yesNo" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item style="margin: 0">
                <el-button type="primary" @click="onSubmit" icon="el-icon-search">{{ $t("common.search") }}</el-button>
                <el-button @click="resetSearch('machine')" icon="el-icon-refresh">{{ $t("common.reset") }}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </div>
    <el-dialog
      :modal-append-to-body="true"
      :append-to-body="true"
      :title="$t('searchMachine.title')"
      :visible.sync="dialogImportMachine"
      width="30%"
      top="9vh"
      @closed="closeDialog"
    >
      <div v-loading="loading">
        <el-upload
          class="upload-demo"
          drag
          accept=".xls,.xlsx"
          multiple
          ref="upload"
          :before-upload="beforeUpload"
          :on-progress="onProgress"
          :on-success="onSuccess"
          limit="1"
          :headers="headers"
          :auto-upload="false"
          :action="url"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            {{ this.$t("searchMachine.text") }}
            <em>{{ this.$t("searchMachine.sub") }}</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            {{ this.$t("searchMachine.tip") }}
          </div>
        </el-upload>
        <vue-scroll>
          <div class="result" v-show="result.length > 0">{{ result }}</div>
        </vue-scroll>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="downloadTemplate" v-hasPerm="['machine:template']" style="float: left">{{
          this.$t("searchMachine.down")
        }}</el-button>
        <el-button @click="dialogImportMachine = !dialogImportMachine">{{ $t("common.cancel") }}</el-button>
        <el-button type="primary" @click="submitUpload()">{{ $t("common.definite") }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import config from "@/http/config";
  export default {
    name: "SearchMachine",
    props: {
      search: Object,
      multipleSelection: Array,
      yesNo: Array,
      appTypeList: Array,
      machineType: Array,
      machineGroup: Array
    },
    data() {
      return {
        loading: false,
        dialogImportMachine: false,
        fileList: [],
        url: config.baseUrl + this.$url.Machine.import,
        headers: {
          token: this.$cookies.get("token")
        },
        result: "",
        importResult: ""
      };
    },
    mounted() {},
    methods: {
      addMachine() {
        this.$emit("addMachine");
      },
      quickAddMachine() {
        this.$emit("quickAddMachine");
      },
      recoverMachine() {
        this.$emit("recoverMachine");
      },
      onSubmit() {
        this.$emit("onSubmit", this.search);
      },
      resetSearch(formName) {
        this.$refs[formName].resetFields();
        this.$toolUtil.clearForm(this.search);
        this.$emit("resetSearch", this.search);
      },
      importMachine() {
        this.dialogImportMachine = true;
      },
      exportMachine() {
        this.$confirm(this.$t("searchMachine.export"), this.$t("common.tip"), {
          confirmButtonText: this.$t("common.definite"),
          cancelButtonText: this.$t("common.cancel"),
          type: "warning"
        }).then(() => {
          this.$api.download(this.$url.Machine.export, this.search);
        });
      },
      downloadTemplate() {
        this.$api.download(this.$url.Machine.template);
      },
      submitUpload() {
        this.$refs.upload.submit();
      },
      beforeUpload(file) {
        let type = false;
        if (file.type === "") {
          let fileName = file.name;
          if (fileName !== "" && (fileName.indexOf(".xls") > 0 || fileName.indexOf(".xlsx") > 0)) {
            type = true;
          } else {
            this.$message.error(this.$t("searchMachine.type"));
          }
        } else {
          type =
            file.type === "application/vnd.ms-excel" ||
            file.type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          if (!type) {
            this.$message.error(this.$t("searchMachine.type"));
          }
        }
        let size = file.size / 1024 < 500;
        if (!size) {
          this.$message.error(this.$t("searchMachine.size"));
        }
        return type && size;
      },
      closeDialog() {
        this.$refs.upload.clearFiles();
        this.$emit("importSuccess", this.importResult);
        this.result = "";
      },
      onProgress() {
        this.loading = true;
      },
      onSuccess(res) {
        if (res.code === 0) {
          this.importResult = JSON.parse(res.data);
          this.result = "";
          this.result = res.msg;
          let msg =
            this.importResult.error > 0
              ? this.$t("searchMachine.impS").replace("N", this.importResult.success) +
                "，" +
                this.$t("searchMachine.impE").replace("N", this.importResult.error)
              : this.$t("searchMachine.impS").replace("N", this.importResult.success);
          this.$notify({
            title: this.$t("common.tip"),
            message: msg,
            type: "success"
          });
        }
        this.loading = false;
      }
    }
  };
</script>

<style lang="scss">
  .search-machine {
    .el-upload--text,
    .el-upload-dragger {
      width: 100%;
    }
    .result {
      margin-top: 10px;
      color: var(--vtm-crit);
      max-height: 60px;
    }
  }
</style>
